import { render, staticRenderFns } from "./keepAlive.vue?vue&type=template&id=39276e0c&scoped=true&"
import script from "./keepAlive.vue?vue&type=script&lang=js&"
export * from "./keepAlive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39276e0c",
  null
  
)

export default component.exports